// extracted by mini-css-extract-plugin
module.exports = {"dataGridWrapper":"mailingAdmin_dataGridWrapper__EfBNz","itemScroll":"mailingAdmin_itemScroll__1c2Xz"};